import { QRCodeSVG } from 'qrcode.react';

export function QR({
  size = 168,
  value,
  dark = '#2B281F',
  light = '#FAFAF8',
}: {
  size?: number;
  value: string;
  dark?: string;
  light?: string;
}) {
  return (
    <QRCodeSVG
      value={value}
      size={size}
      bgColor={light}
      fgColor={dark}
      level="M"
      marginSize={2}
      style={{ background: light, border: `3px solid ${dark}`, display: 'block' }}
    />
  );
}
